import React from 'react';
import { Popover } from 'react-bootstrap';
import { BSOverlay } from '~/components/Bootstrap';
import { formatAddress } from '~/util';

export interface ProviderAddressProps {
    name: string;
    srName?: string;
    address?: AddressType;
    phone?: PhoneType | undefined;
    fax?: PhoneType | undefined;
    isDefault?: boolean;
    tooltipNote?: string;
    isGenericAddress?: boolean;
}
export function ProviderAddress({
    name,
    srName,
    address,
    phone,
    fax,
    isDefault,
    tooltipNote,
    isGenericAddress = false,
}: ProviderAddressProps) {
    return (
        <span className="text-nowrap d-flex">
            <span className="me-1 text-truncate overflow-hidden" title={name}>
                {name}
            </span>
            {isDefault && '(Default) '}
            {address?.distance ? (
                `(${address.distance.toFixed(1)} mi)`
            ) : (
                <span title="Distance from patient to provider cannot be shown at this time">
                    (-- mi)
                </span>
            )}
            <BSOverlay
                delay={{ show: 1500, hide: 0 }}
                placement="top"
                overlay={
                    <Popover>
                        <Popover.Body>
                            {!address ? (
                                <span>
                                    Address is not available for this{' '}
                                    {isGenericAddress ? 'provider' : 'location'}.
                                </span>
                            ) : (
                                <>
                                    {formatAddress(address).map((line) => (
                                        <div key={line}>{line}</div>
                                    ))}
                                    {phone && (
                                        <div>
                                            Phone: {phone.number}
                                            {phone.extension && ` Ext. ${phone.extension}`}
                                        </div>
                                    )}
                                    {fax && (
                                        <div>
                                            Fax: {fax.number}
                                            {fax.extension && ` Ext. ${fax.extension}`}
                                        </div>
                                    )}
                                    {tooltipNote && (
                                        <div>
                                            <br />
                                            {tooltipNote}
                                        </div>
                                    )}
                                </>
                            )}
                        </Popover.Body>
                    </Popover>
                }
            >
                <i className="fa-solid fa-location-dot ms-2 lh-base">
                    <span className="sr-only">{`${srName || name} Address`}</span>
                </i>
            </BSOverlay>
        </span>
    );
}
